import { HttpService } from "./http.service";

const basePath = "/TooltipDescription";
const request = HttpService.handleRequest();

export const TooltipDescriptionService = {
  GetByFieldLocale
};

async function GetByFieldLocale(fieldId, localeId) {
  return request.get(`${basePath}/GetByFieldLocale/${fieldId}/${localeId}`);
}

export default TooltipDescriptionService;